import { httpsCallable } from 'firebase/functions';
import {
  WebCallResponse,
  PhoneCallResponse,
  CallListParams,
} from 'retell-sdk/resources/call';

import { functions } from '../../../firebase.js';

export interface CollectWiseRetellPhoneCall extends PhoneCallResponse {
  accountId: string | null;
  to_number_formatted?: string | null;
  from_number_formatted?: string | null;
  timestamp: number;
  debtorId?: string | null;
  debtorFirstName?: string | null;
  debtorLastName?: string | null;
  variations?: string[];
  clientId?: string | null;
  fileNumber?: string | null;
}

export interface RangeFilter {
  lower_threshold?: number;
  upper_threshold?: number;
}

export interface CollectWiseSearchParams extends CallListParams {
  name?: string;
  clientId?: string;
  lastDocumentId?: string;
}

type CallResponse = WebCallResponse | PhoneCallResponse;

export function isWebCall(call: CallResponse): call is WebCallResponse {
  return call.call_type === 'web_call';
}

export function isPhoneCall(call: CallResponse): call is PhoneCallResponse {
  return call.call_type === 'phone_call';
}

export interface CollectWiseRetellCallsResponse {
  calls: CollectWiseRetellPhoneCall[];
  hasMore: boolean;
  lastDocumentId?: string | null;
}

const listRetellCallsFunction = httpsCallable<
  CollectWiseSearchParams,
  CollectWiseRetellCallsResponse
>(functions, 'listRetellCalls');

export const listRetellCalls = async (
  params: CollectWiseSearchParams
): Promise<CollectWiseRetellCallsResponse> => {
  const result = await listRetellCallsFunction(params);
  return result.data;
};
